import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  fetchActiveInventory,
  fetchPastUnitsSales,
  fetchPredictedUnits,
  fetchSellerForecastReviews,
} from "../../../../../redux/slices/store_analytics";
import { trackEvent } from "../../../../../utils/analytics";
import InventoryCapacity from "../InventoryCapacity";

import Operations from "./Operations";
import SellerForecast from "./SellerForecast";

const TAB_NAMES = ["Operations", "Seller Forecast", "Inventory & Capacity"];

const StoreProducts = ({ store, marketplace = "us" }) => {
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    if (store === "all") return;

    const fetchData = async () => {
      try {
        dispatch(fetchActiveInventory({ store, marketplace }));
        dispatch(fetchPredictedUnits({ store, marketplace, months: 7 }));
        dispatch(fetchSellerForecastReviews({ store, marketplace }));
        dispatch(fetchPastUnitsSales({ store, marketplace }));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [store, marketplace, dispatch]);

  const handleTabChange = (_, newValue) => {
    trackEvent("inventory_tab_change", {
      tab_name: TAB_NAMES[newValue] || newValue,
      store,
    });
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label="store products tabs"
        >
          <Tab label="Operations" />
          <Tab label="Seller Forecast" />
          <Tab label="Inventory & Capacity" />
        </Tabs>
      </Box>

      {currentTab === 0 &&
        (store === "all" ? (
          <Box p={3}>Please select a specific store to view operations.</Box>
        ) : (
          <Operations store={store} marketplace={marketplace} />
        ))}
      {currentTab === 1 &&
        (store === "all" ? (
          <Box p={3}>
            Please select a specific store to view seller forecast.
          </Box>
        ) : (
          <SellerForecast store={store} marketplace={marketplace} />
        ))}
      {currentTab === 2 &&
        (store === "all" ? (
          <Box p={3}>
            Please select a specific store to view inventory and capacity.
          </Box>
        ) : (
          <InventoryCapacity store={store} marketplace={marketplace} />
        ))}
    </Box>
  );
};

export default StoreProducts;
